import { MultiSelectDropdown } from "@/app/components/MultiSelectDropdown";
import {
  sourceSystemOptions,
  resourceOptions,
} from "../helpers/pagHelpers";
import type { PagSourceSystemFilter } from "../services/pagApi";

export interface SourceSystemResourceFilterProps {
  sourceSystemFilters: PagSourceSystemFilter[];
  sourceSystems: string[];
  resources: string[];
  onSourceSystemsChange: (next: string[]) => void;
  onResourcesChange: (next: string[]) => void;
}

export function SourceSystemResourceFilter({
  sourceSystemFilters,
  sourceSystems,
  resources,
  onSourceSystemsChange,
  onResourcesChange,
}: SourceSystemResourceFilterProps) {
  return (
    <>
      <div className="flex w-full min-w-[180px] flex-col gap-1.5 sm:w-[200px]">
        <span className="text-[10px] font-semibold tracking-wide text-muted-foreground">
          Source System
        </span>
        <MultiSelectDropdown
          variant="form"
          selectAll
          options={sourceSystemOptions(sourceSystemFilters)}
          selected={sourceSystems}
          onChange={onSourceSystemsChange}
          placeholder="Select source"
          selectedNoun="Systems"
        />
      </div>
      <div className="flex w-full min-w-[200px] flex-col gap-1.5 sm:w-[240px]">
        <span className="text-[10px] font-semibold tracking-wide text-muted-foreground">
          Resources
        </span>
        <MultiSelectDropdown
          variant="form"
          searchable
          selectAll
          options={resourceOptions(sourceSystemFilters, sourceSystems)}
          selected={resources}
          onChange={onResourcesChange}
          placeholder="Select resource"
          selectedNoun="Resources"
        />
      </div>
    </>
  );
}
